import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useContext, useState } from 'react';
import { InTableContext } from './TableContext';

// Shows the first `displayCount` words. Inside tables the rest is in a
// tooltip (rows have a fixed height); elsewhere "+N more" expands the list in
// place, which also works on touch screens.
function TruncateWords({ words, displayCount, separator, sx }) {
  const inTable = useContext(InTableContext);
  const [expanded, setExpanded] = useState(false);

  const hiddenCount = words.length - displayCount;
  const allWords = words.join(separator);
  const textSx = { fontSize: '0.75rem', ...sx };

  if (hiddenCount <= 0) {
    return <Typography sx={textSx}>{allWords}</Typography>;
  }

  const visibleWords = words.slice(0, displayCount).join(separator);

  if (inTable) {
    return (
      <Tooltip title={allWords} arrow>
        <Typography sx={{ ...textSx, cursor: 'default' }} noWrap>
          {visibleWords}
          <Typography
            component="span"
            sx={{ ml: 0.75, fontSize: 'inherit', fontWeight: 600, color: 'text.secondary' }}
          >
            +{hiddenCount}
          </Typography>
        </Typography>
      </Tooltip>
    );
  }

  return (
    <Typography sx={textSx}>
      {expanded ? allWords : visibleWords}
      <Link
        component="button"
        type="button"
        underline="hover"
        onClick={() => setExpanded(!expanded)}
        sx={{
          ml: 0.75,
          fontSize: 'inherit',
          fontWeight: 600,
          verticalAlign: 'baseline',
          color: 'text.secondary',
        }}
      >
        {expanded ? 'Show less' : `+${hiddenCount} more`}
      </Link>
    </Typography>
  );
}

export default TruncateWords;
